export const rescheduleColumns = "0.8fr 1.5fr 1fr 1fr 1fr";
